import React from "react";
import ReactTooltip from "react-tooltip";
import { translate } from "../../../infrastructure/translate/localization";

function EmployeesPage() {
  return (
    <main className="section">
      <ReactTooltip
        className="tooltipMessage"
        place="top"
        effect="solid"
        type="light"
        delayShow={500}
      />
      <div className="section-header">
        <h1 className="section-title">
          {translate("employees-section.employees")}
        </h1>
        <div id="notification-card" />
      </div>
      <div className="section-container">
        <div className="container-flex" id="table-active-employees-container" />
      </div>
    </main>
  );
}

export default EmployeesPage;
